(function () {
  const header = document.querySelector(".header--mega-redesign");
  if (!header) return;

  const hoverRoot = header.closest(".header-wrapper") || header;
  const navItems = header.querySelectorAll(".mmr-item");
  const items = header.querySelectorAll(".mmr-item--has-panel");
  const desktopNav = window.matchMedia("(min-width: 990px)").matches;
  const canHover =
    window.matchMedia("(hover: hover) and (pointer: fine)").matches || desktopNav;
  let closeTimer = null;

  const closeAll = (except) => {
    items.forEach((item) => {
      if (item !== except) {
        item.classList.remove("is-open");
        const trigger = item.querySelector(".mmr-link");
        if (trigger) trigger.setAttribute("aria-expanded", "false");
      }
    });
  };

  const openItem = (item) => {
    item.classList.add("is-open");
    const trigger = item.querySelector(".mmr-link");
    if (trigger) trigger.setAttribute("aria-expanded", "true");
    closeAll(item);
  };

  const closeItem = (item) => {
    item.classList.remove("is-open");
    const trigger = item.querySelector(".mmr-link");
    if (trigger) trigger.setAttribute("aria-expanded", "false");
  };

  navItems.forEach((item) => {
    const trigger = item.querySelector(".mmr-link");
    const hasPanel = item.classList.contains("mmr-item--has-panel");

    if (canHover) {
      trigger?.addEventListener("mouseenter", () => {
        window.clearTimeout(closeTimer);
        if (hasPanel) {
          openItem(item);
        } else {
          closeAll();
        }
      });
      item.querySelector(".mmr-dropdown")?.addEventListener("mouseenter", () => {
        window.clearTimeout(closeTimer);
      });
    } else if (hasPanel) {
      trigger?.addEventListener("click", (event) => {
        const isOpen = item.classList.contains("is-open");
        if (!isOpen) {
          event.preventDefault();
          openItem(item);
        }
      });
    }

    if (hasPanel) {
      trigger?.addEventListener("focus", () => openItem(item));
      item.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
          closeItem(item);
          trigger?.focus();
        }
      });
    } else {
      trigger?.addEventListener("focus", () => closeAll());
    }
  });

  if (canHover) {
    hoverRoot.addEventListener("mouseenter", () => {
      window.clearTimeout(closeTimer);
    });
    hoverRoot.addEventListener("mouseleave", () => {
      closeTimer = window.setTimeout(() => closeAll(), 80);
    });
  }

  document.addEventListener("click", (event) => {
    if (!header.contains(event.target)) closeAll();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeAll();
  });

  header.querySelectorAll("[data-mmr-hover-cards], [data-all-bedding-menu]").forEach((root) => {
    if (root.hasAttribute("data-mmr-static-card")) return;
    // Only primary column categories switch cards. Nested child/grandchild
    // .mmr-bedding-cat links (Shop by Collection, .mmr-sub, etc.) must not.
    const cats = Array.from(root.querySelectorAll(".mmr-bedding-cat")).filter((cat) => {
      return !cat.closest(".mmr-sub") && !cat.closest(".sub-category-list") && !cat.closest(".grandchild-list");
    });
    const cards = root.querySelectorAll(".mmr-bedding-card");
    if (!cats.length || !cards.length) return;

    const showCard = (key) => {
      cats.forEach((cat) => {
        cat.classList.toggle("is-active", cat.getAttribute("data-card") === key);
      });
      cards.forEach((card) => {
        card.classList.toggle("is-hidden", card.getAttribute("data-card") !== key);
      });
    };

    cats.forEach((cat) => {
      cat.addEventListener("mouseenter", () => showCard(cat.getAttribute("data-card")));
      cat.addEventListener("focusin", () => showCard(cat.getAttribute("data-card")));
    });
  });
})();
